import { useEffect, useState } from "react";
import styles from "./girlpower.module.css";
import Section from "../Section";
import { Modal } from "antd";
import ScheduleCourtesy from "../../scheduleCourtesy/scheduleCourtesy";
import { IoVolumeMute } from "react-icons/io5";
import { VscUnmute } from "react-icons/vsc";

const GirlPower = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const button = document.getElementById("sound");
    const videos = document.querySelectorAll(".landingVideo");
    const volumeOff = document.getElementById("volume_off");
    const volumeOn = document.getElementById("volume_on");

    button.onclick = function () {
      volumeOff.style.display =
        window.getComputedStyle(volumeOff).display === "none"
          ? "block"
          : "none";
      volumeOn.style.display =
        window.getComputedStyle(volumeOn).display === "none" ? "block" : "none";

      videos.forEach((video) => {
        if (window.getComputedStyle(video).display !== "none")
          video.muted = !video.muted;
      });
    };

    // Intersection Observer for videos
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          if (video.paused) {
            video.play();
          }
        } else {
          if (!video.paused) {
            video.pause();
          }
        }
      });
    }, options);

    const targets = document.querySelectorAll(".landingVideo");
    targets.forEach((target) => observer.observe(target));

    const scheduleCourtesyButton = document.getElementById("schedule-courtesy");
    if (scheduleCourtesyButton) {
      setTimeout(() => {
        scheduleCourtesyButton.style.display = "block";
        scheduleCourtesyButton.classList.add("fade-in");
      }, 1000);
    }
  }, []);

  const Banner = () => {
    return (
      <div className={`${styles.bgBrand} w-100 text-center p-5`}>
        <h3>CENTRO DE BIENESTAR EXCLUSIVO PARA MUJERES</h3>
      </div>
    );
  }

  return (
    <>
      <div id="welcome" className="flex-center full-height position-relative">
        <div className="content h-100 w-100">
          <div className="title h-100 w-100">
            <video
              autoPlay
              muted
              className="portrait-video landingVideo"
              src="/video/girlPower/landing_page_portrait.mp4" // TODO: change for landscape when available
              preload="auto"
            ></video>
            <video
              muted
              className="landscape-video landingVideo"
              src="/video/girlPower/landing_page_portrait.mp4" // TODO: change for landscape when available
              preload="none"
            ></video>
            <button
              id="schedule-courtesy"
              className={`${styles.scheduleCourtesy} btn ml-auto mr-auto`}
              onClick={() => setShowModal(true)}
              style={{width: "max-content"}}
            >
              ¡Agendar Cortesía!
            </button>
            <button
              id="sound"
              className="btn position-absolute bg-dark text-white"
              style={{
                bottom: "5vh",
                left: "5vh",
                height: "40px",
                lineHeight: 0,
              }}
            >
              <span
                id="volume_off"
                style={{ fontSize: "smaller" }}
              >
                <IoVolumeMute size={22} />
              </span>
              <span
                id="volume_on"
                style={{ fontSize: "smaller", display: "none" }}
              >
                <VscUnmute size={22} />
              </span>
            </button>
          </div>
        </div>
      </div>
      <div>
        <Banner />
        <Section
          title={"Fit Flyr"}
          description={"Entrenamiento de rebote que reduce 80% el impacto y quema 20% más calorías"}
          video={"/video/girlPower/fit_flyr.mp4"}
          background={"#ffffff"}
          color={"black"}
        />
        <Section
          title={"Fit Functional"}
          description={"Mezcla de crossfit que mejora la vida diaria al fortalecer movimientos naturales y el núcleo, promoviendo la salud y la funcionalidad. 💪🏋️‍"}
          video={"/video/girlPower/fit_functional.mp4"}
          background={"linear-gradient(90deg, rgba(67,0,36,1) 0%, rgba(67,5,68,1) 72%, rgba(87,6,88,1) 100%)"}
          color={"white"}
          titleClassName={styles.fitFunctionalTitle}
        />
        <Section
          title={"Fit Flex"}
          description={"Combinación de yoga con pilates 🤸♀"}
          video={"/video/girlPower/fit_flex.mp4"}
          background={"#ffffff"}
          color={"black"}
        />
         <Section
          title={"Fit Jump"}
          description={"Rebote en trampolin al ritmo de la mejor música"}
          img={"/img/landing/girlPower/exercise/jump.jpg"}
          background={"linear-gradient(90deg, rgba(67,0,36,1) 0%, rgba(67,5,68,1) 72%, rgba(87,6,88,1) 100%)"}
          color={"white"}
        />
        <Section
          title={"Fit Box"}
          description={"El boxeo es un arte marcial y deporte que combina fuerza, velocidad y estrategia, donde los puños son las herramientas de expresión, para desestresarte y sacar el fuego que llevas por dentro. 🥊 💥‍"}
          video={"/video/girlPower/fit_box.mp4"}
          background={"#ffffff"}
          color={"black"}
        />
        <Section
          title={"Fit Step"}
          description={"Tonifica, has cardio, sube y baja al mejor ritmo de la música"}
          img={"/img/landing/girlPower/exercise/step.JPG"}
          background={"linear-gradient(90deg, rgba(67,0,36,1) 0%, rgba(67,5,68,1) 72%, rgba(87,6,88,1) 100%)"}
          color={"white"}
        />
        <Section
          title={"Fit Dance"}
          description={"Rumboterapia al ritmo de 4 generos músicales 💃"}
          img={"/img/landing/girlPower/exercise/dance.JPG"}
          background={"#ffffff"}
          color={"black"}
        />
        <Section
          title={"Fit Combat"}
          description={"Mezcla de artes marciales al ritmo de la música 🤼"}
          img={"/img/landing/girlPower/exercise/combat.JPG"}
          background={"linear-gradient(90deg, rgba(67,0,36,1) 0%, rgba(67,5,68,1) 72%, rgba(87,6,88,1) 100%)"}
          color={"white"}
        />
        <Section
          title={"Y mucho más"}
          description={""}
          img={"/img/landing/girlPower/exercise/all_exercises.JPG"}
          background={"#ffffff"}
          color={"black"}
        />
      </div>
      <Modal
        open={showModal}
        onCancel={() => setShowModal(false)}
        footer={null}
        width={800}
        destroyOnClose
      >
        <ScheduleCourtesy onSuccess={() => setShowModal(false)}/>
      </Modal>
    </>
  );
};

export default GirlPower;
